package music.jammers.client.shared.signin.models

sealed interface AuthResponse {
    data class Success(val token: String) : AuthResponse
    data class Error(val value: GoogleAuthError) : AuthResponse
    data object Progress : AuthResponse
    data object Cancelled : AuthResponse
}
